(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/team-list/assets/javascripts/team-list.js') >= 0) return;  svs.modules.push('/components/marketplace/team-list/assets/javascripts/team-list.js');

'use strict';

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const GroupList = svs.components.marketplace.groupList.GroupList;
const TeamListItem = svs.components.marketplace.teamList.TeamListItem;
const helpers = svs.components.marketplace.helpers;
const getColor = svs.components.marketplace.colorHelper.getColor;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$components$marke = svs.components.marketplaceData.selectors.teams,
  getTeams = _svs$components$marke.getTeams,
  getRetailers = _svs$components$marke.getRetailers;
const selectChatRooms = svs.components.marketplaceData.selectors.chat.selectChatRooms;
const TeamList = _ref => {
  let isBrowseGames = _ref.isBrowseGames,
    isRetail = _ref.isRetail,
    children = _ref.children,
    renderOnEmpty = _ref.renderOnEmpty,
    isHeaderInverted = _ref.isHeaderInverted,
    teamClassName = _ref.teamClassName,
    teamLinkSearch = _ref.teamLinkSearch,
    maxGamesToDisplay = _ref.maxGamesToDisplay,
    offsetForLastClicked = _ref.offsetForLastClicked,
    shouldUseLastClicked = _ref.shouldUseLastClicked;
  const history = useHistory();
  const teams = useSelector(state => getTeams(state));
  const retailers = useSelector(state => getRetailers(state, isBrowseGames) || []);
  const chatRooms = useSelector(state => selectChatRooms(state));
  return React.createElement(GroupList, {
    listData: isRetail ? retailers : teams,
    renderItem: (team, key) => React.createElement(TeamListItem, {
      className: teamClassName,
      color: getColor(team.id),
      history: history,
      isHeaderInverted: isHeaderInverted,
      isRetail: isRetail,
      key: team.id || key,
      linkTo: {
        pathname: isRetail ? helpers.getRetailUrl(team.id, team.name) : helpers.getTeamUrl(team.id, team.name),
        search: teamLinkSearch
      },
      maxGamesToDisplay: maxGamesToDisplay,
      onClick: () => {
        if (shouldUseLastClicked) {
          svs.components.Storage.browser.set('lastClickedTeam', 'marketplace', {
            groupId: team.id,
            offset: offsetForLastClicked
          });
        }
      },
      team: team,
      unreadMessages: (chatRooms["marketplace_".concat(team.id)] || {}).unread
    }, children(team)),
    renderOnEmpty: renderOnEmpty
  });
};
TeamList.defaultProps = {
  children: () => {},
  isHeaderInverted: false,
  isRetail: false
};
setGlobal('svs.components.marketplace.teamList.TeamList', TeamList);

 })(window);